import { Controller } from "@hotwired/stimulus"

export default class PollerController extends Controller {
  static values = { url: String, refreshInterval: Number }

  connect() {
    setTimeout(() => {
      this.load()
    }, this.refreshIntervalValue)
  }

  load() {
    fetch(this.urlValue)
      .then((response) => response.text())
      .then((html) => {
        this.element.parentNode.outerHTML = html
      })
  }
}
